import { glossary as GLOSSARY } from 'constants/glossary';
import { get } from 'lodash';

exports.getHelpText = ({ glossaryKey, glossary = GLOSSARY }) => {
    const helptext = get(
        glossary,
        `${glossaryKey}.tooltip`,
        get(glossary, `${glossaryKey}.definition`));

    return helptext;
};

/**
In the future this should be extended to handle the logic required to conditionally
render certain definitions/glossary terms depending on configuration such as labelCode
or entity/brand
*/
exports.prepareGlossaryData = (glossary, userScope) => {
    const userScopes = userScope || [];
    const glossaryList = Object.keys(glossary).reduce((acc, glossaryKey) => {
        const { scope } = glossary[glossaryKey];

        let inScope = true;
        if (scope) {
            let scopeList = scope;

            if (!Array.isArray(scope)) {
                scopeList = [scopeList];
            }

            for (const scopeKey of scopeList) {
                if (!userScopes.includes(scopeKey)) {
                    inScope = false;
                }
            }
        }

        // TODO: What is the purpose of this protective check?
        if (glossary[glossaryKey].labelCode !== 'sales' && inScope) {
            acc.push({
                term: glossary[glossaryKey].displayName,
                definition: glossary[glossaryKey].definition,
            });
        }
        return acc;
    }, []);

    return glossaryList;
};



// WEBPACK FOOTER //
// ./src/helpers/glossary.js